{
  "page": {
    "loading": "Loading competition…",
    "unavailable": "This competition is not publicly available.",
    "register": "Register",
    "registering": "Registering…",
    "registerError": "Could not complete registration. Please try again.",
    "registrationNotOpen": "Registration is not currently open.",
    "signInToRegister": "Sign in to register",
    "submitEntry": "Submit an entry",
    "registrationForm": "Registration form",
    "registrationFormHint": "Fill out the form below to complete registration.",
    "importantDates": "Important dates",
    "registration": "Registration",
    "submission": "Submission",
    "resultPublish": "Results published",
    "tba": "TBA",
    "categories": "Categories",
    "announcements": "Announcements",
    "eligibility": "Eligibility",
    "submissionRequirements": "Submission Requirements",
    "judgingCriteria": "Judging Criteria",
    "prizes": "Prizes",
    "organizerContact": "Organizer Contact",
    "faq": "FAQ",
    "countdown": {
      "until": "Counting down to:",
      "none": "There is no upcoming deadline right now.",
      "days": "days",
      "hours": "hrs",
      "minutes": "min"
    },
    "phaseTimeline": {
      "current": "In progress",
      "completed": "Ended"
    },
    "highlights": {
      "title": "Highlights",
      "teamSizeRange": "{{min}}–{{max}} members per team",
      "individual": "Individual entry",
      "advisorRequired": "An advisor is required",
      "advisorAllowed": "An advisor is allowed",
      "advisorNotAllowed": "Advisors are not part of this competition"
    },
    "process": {
      "title": "Process",
      "current": "Current: {{step}}",
      "steps": {
        "registration": "Registration",
        "submission": "Submission",
        "judging": "Judging",
        "results": "Results"
      }
    },
    "stickyCta": {
      "action": "Go now"
    },
    "hero": {
      "deadlineLine": "{{milestone}}: {{deadline}}",
      "viewRules": "View competition rules",
      "timezoneNote": "All times above are shown in {{timezone}}.",
      "status": {
        "published": "Opening soon",
        "registration_open": "Registration open",
        "submission_open": "Submissions open",
        "judging": "Judging in progress",
        "completed": "Completed"
      },
      "explanation": {
        "registration_open": "Registration is open for this competition.",
        "registration_closed_submission_open": "Registration has closed. Registered participants may still submit their entry before {{deadline}}.",
        "registration_closed_judging": "Registration and submissions have both closed. Entries are currently being judged.",
        "not_open_generic": "Registration is not open at this stage; check back for announcements.",
        "completed": "This competition has concluded."
      },
      "milestone": {
        "registration_opens": "Registration opens",
        "registration_closes": "Registration closes",
        "submission_closes": "Submission closes",
        "result_publication": "Results published"
      },
      "cta": {
        "signInToRegister": "Sign in to register",
        "registerNow": "Register now",
        "completeRegistration": "Complete registration",
        "manageTeam": "Manage team",
        "submitEntry": "Submit entry",
        "continueSubmission": "Continue submission",
        "checkAndSubmit": "Check and submit",
        "correctionRequired": "View and fix your entry",
        "viewReceipt": "View submission receipt",
        "viewSubmitted": "View submitted work",
        "viewResults": "View results",
        "registrationClosed": "Registration closed",
        "notOpenYet": "Not open yet",
        "registeredAwaitingSubmission": "Registration complete",
        "submissionMissed": "View competition details"
      }
    }
  }
}
